import { render, staticRenderFns } from "./TranslationTab.vue?vue&type=template&id=20910eb4"
import script from "./TranslationTab.vue?vue&type=script&lang=js"
export * from "./TranslationTab.vue?vue&type=script&lang=js"
import style0 from "./TranslationTab.vue?vue&type=style&index=0&id=20910eb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports